import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import Learn from "@/views/learn/Learn";
import LearnBranding from "@/views/learn/LearnBranding.vue"
import Mobile from "@/views/learn/Mobile.vue"
import Unbox from "@/views/learn/Unbox.vue"
import Upload from "@/views/learn/Upload.vue"
import Uploader from "@/views/learn/Uploader.vue"
import Capture from "@/views/learn/Capture.vue"
import PrerecordChecklist from "@/views/PrerecordChecklist";
import Account from "@/views/Account";
import AuthService from "@/services/AuthService";
import JustSubscribed from "@/views/JustSubscribed";
import JustBoughtCamera from "@/views/JustBoughtCamera";
import Team from "@/views/Team"
import Branding from "@/views/Branding";
import QrCodeTool from "@/views/QrCodeTool";

Vue.use(VueRouter)

function requireAuth(to, from, next) {
  // console.log(`requireAuth(${to}, ${from}, ${next})`)
  console.log('beforeEnter')

  let loginPath = '/login'

  let query = {}

  if(!AuthService.isLoggedIn()) {
    if(to.fullPath.trim().length > 0 ){

      query.redirect = to.fullPath

      console.log(`next(${
        {
          path: loginPath,
          query: query
        }
      })`)

      next({
        path: loginPath,
        query: query
      })
    } else {

      console.log(`next(${
        {
          path: loginPath,
          query: query
        }
      })`)

      next({
        path: loginPath,
        query: query
      })
    }
  } else {
    console.log('next()')
    next()
  }
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    alias: ['/', '/#/'],
    name: 'Home',
    component: Home,
    beforeEnter: requireAuth
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    beforeEnter: requireAuth
  },
  {
    path: '/learn',
    name: 'Learn',
    component: Learn,
    // beforeEnter: requireAuth
  },
  {
    path: '/learn/branding',
    name: 'LearnBranding',
    component: LearnBranding,
    // beforeEnter: requireAuth
  },
  {
    path: '/learn/mobile',
    name: 'Mobile',
    component: Mobile,
    // beforeEnter: requireAuth
  },
  {
    path: '/learn/unbox',
    name: 'Unbox',
    component: Unbox,
    // beforeEnter: requireAuth
  },
  {
    path: '/learn/upload',
    name: 'Upload',
    component: Upload,
    // beforeEnter: requireAuth
  },
  {
    path: '/learn/uploader',
    name: 'Uploader',
    component: Uploader,
    // beforeEnter: requireAuth
  },
  {
    path: '/learn/capture',
    name: 'Capture',
    component: Capture,
    // beforeEnter: requireAuth
  },
  {
    path: '/learn/checklist',
    name: 'Checklist',
    component: PrerecordChecklist,
    // beforeEnter: requireAuth
  },
  {
    path: '/checklist',
    name: 'checklist',
    component: PrerecordChecklist
  },
  {
    path: '/qrcode',
    name: 'qrcode',
    component: QrCodeTool
  },
  {
    path: '/justSubscribed',
    name: 'JustSubscribed',
    component: JustSubscribed,
    beforeEnter: requireAuth
  },
  {
    path: '/justBoughtCamera',
    name: 'JustBoughtCamera',
    component: JustBoughtCamera,
    beforeEnter: requireAuth
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
    beforeEnter: requireAuth
  },
  {
    path: '/branding',
    name: 'Branding',
    component: Branding,
    beforeEnter: requireAuth
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {

  if(to.query?.promoCode) {
    console.log(`promoCode: ${to.query.promoCode}`)
    localStorage.setItem('promo-code', to.query.promoCode)
  }

  if(to.query?.subscriptionQuantity) {
    try {
      console.log(`subscriptionQuantity: ${to.query.subscriptionQuantity}`)
      localStorage.setItem('subscription-quantity', to.query.subscriptionQuantity)
    } catch {

    }
  }

  if(to.query?.cameraQuantity) {
    try {
      localStorage.setItem('camera-quantity', to.query.cameraQuantity)
      console.log(`cameraQuantity: ${to.query.cameraQuantity}`)
    } catch {

    }
  }

  console.log('beforeEach authcheck')
  await AuthService.authCheck()
  next()
})

export default router
